import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import TabsComponent from "./utils/TabsComponent/TabsComponent";
import { useLocation } from "react-router-dom";

const MainContainer = ({
  children,
  offPadding,
  hideTabs = true,
  setSearchValue,
  fullWidth,
  hideOverflowX,
}) => {
  const location = useLocation();

  const [scrollDown, setScrollDown] = useState(false);
  const lastScrollY = useRef(0);

  const alreadyGeneratedVideo = localStorage.getItem("alreadyGeneratedVideo");

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      // Always false if scroll is at the top
      if (currentY <= 0) {
        setScrollDown(false);
        lastScrollY.current = 0;
        return;
      }

      // Scroll down -> true
      if (currentY > lastScrollY.current + 5) {
        setScrollDown((prev) => (prev ? prev : true));
        // Scroll down -> false
      } else if (currentY < lastScrollY.current - 5) {
        setScrollDown((prev) => (prev ? false : prev));
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setScrollDown(false);
  }, [location]);

  return (
    <Container>
      <Header />
      {!hideTabs && (
        <TabsComponent hidden={scrollDown} setSearchValue={setSearchValue} />
      )}
      <Content
        $offPadding={offPadding}
        $hideTabs={hideTabs}
        $fullWidth={fullWidth}
        $alreadyGeneratedVideo={alreadyGeneratedVideo}
        $hideOverflowX={hideOverflowX}
      >
        {children} <Footer />
      </Content>
    </Container>
  );
};

export default MainContainer;

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100dvh;
  /* Transparent so the fixed blue gradient on body::before shows through. */
  background-color: transparent;
  color: white;
  width: 100%;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  min-height: 100dvh;
  padding: ${(props) => (props.$offPadding ? "0rem" : "2rem")};
  padding-top: ${({ $hideTabs, $alreadyGeneratedVideo }) =>
    `calc(64px + ${
      !$hideTabs ? ($alreadyGeneratedVideo ? "64px" : "97px") : "0px"
    })`};
  color: white;
  transition: color 0.3s ease;
  max-width: ${(props) => (props.$fullWidth ? "unset" : "1440px")};

  gap: ${({ $hideTabs }) => (!$hideTabs ? 0 : "16px")};
  overflow-x: ${(p) => (p.$hideOverflowX ? "hidden" : "unset")};
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
